import React, { memo, FC } from "react";
import { css } from "linaria";

const FirstAssetStyles = css`
  width: 3.75rem;
  height: 3.75rem;
  flex: 0 0 3.75rem;
`;

interface Props {
  className?: string;
  feature: any;
}

const PremiumFeature: FC<Props> = (props) => {
  const {
    className,
    feature: {
      item: { kind, cost, resources },
    },
  } = props;

  const primaryAsset = resources[0];
  const resourcesNum = resources.length;

  let featureImage;
  switch (kind) {
    case "page_styles":
      featureImage = (
        <img className="w-11 h-11" src={primaryAsset?.asset?.renditions?.original?.url} />
      );
      break;
    case "color_collections":
      featureImage = (
        <img className="w-7 h-7 rounded-full" src={primaryAsset?.asset?.renditions?.original?.url} />
      );
      break;
    case "image":
    default:
      featureImage = <img className="w-11 h-11" src={primaryAsset?.asset?.renditions?.original?.url} />;
      break;
  }

  let premiumType = "asset";
  switch (kind) {
    case "page_styles":
      premiumType = resourcesNum > 1 ? "styles" : "style";
      break;
    case "color_collections":
      premiumType = resourcesNum > 1 ? "colors" : "color";
      break;
    case "backdrop":
      premiumType = resourcesNum > 1 ? "backdrops" : "backdrop";
      break;
    case "sticker":
      premiumType = resourcesNum > 1 ? "stickers" : "sticker";
      break;
  }

  return (
    <div className={`flex items-center text-lapel ${className}`}>
      <div className="relative">
        {resourcesNum > 2 && (
          <div className="absolute left-6 top-2 w-11 h-11 bg-white rounded border border-dove" />
        )}
        {resourcesNum > 1 && (
          <div className="absolute left-3 top-1 w-13 h-13 bg-white rounded border border-dove" />
        )}
        <div
          className={`relative flex items-center justify-center bg-white rounded border border-dove ${FirstAssetStyles}`}
        >
          {featureImage}
        </div>
      </div>
      <span className="px-4">Premium {premiumType}</span>
      <span className="text-right flex-grow">{`${cost} ${
        cost > 1 ? "Coins" : "Coin"
      }`}</span>
    </div>
  );
};

export default memo(PremiumFeature);
